// extracted by mini-css-extract-plugin
module.exports = {"wideScreenAdAnchor":"StickySideAd_wideScreenAdAnchor__nwcyQ","bottomGradient":"StickySideAd_bottomGradient__dM5Gh","widescreenAd":"StickySideAd_widescreenAd__AQRun"};